// 此 bus 仅用于 kuToolSdk 与 ku 之间的通信
import EventEmitter from 'events';
import type {IEvent} from '@baidu/ku-tool-sdk';

const kuToolEvent = new EventEmitter();
export default kuToolEvent;

export {EventKeys} from '@baidu/ku-tool-sdk';

export function getKuToolEvent(): IEvent {
    return kuToolEvent;
}
